import React from 'react';
import Mainrouter from './components/MainRouter';

function App() {
  return <Mainrouter />;
}

export default App;
